
import init from "./../components/_accordions";

jQuery(function ($) {

    if (animation_loadmore_params.max_page < 2) {
        $('[js-more-anims]').hide();
    } else {
        $('[js-more-anims]').show();
    }

    $('[js-more-anims]').click(function () {

        $.ajax({
            url: animation_loadmore_params.ajaxurl, // AJAX handler
            data: {
                'action': 'animations_loadmorebutton', // the parameter for admin-ajax.php
                'query': animation_loadmore_params.posts, // loop parameters passed by wp_localize_script()
                'page': animation_loadmore_params.current_page // current page
            },
            type: 'POST',
            beforeSend: function (xhr) {
                $('[js-more-anims]').text(animation_loadmore_params.loading_text); // some type of preloader

            },
            success: function (posts) {
                if (posts) {

                    $('[js-more-anims]').text(animation_loadmore_params.btn_text);
                    $('[js-anim-results]').append(posts); // insert new posts
                    init();
                    animation_loadmore_params.current_page++;


                    if (animation_loadmore_params.current_page == animation_loadmore_params.max_page)
                        $('[js-more-anims]').hide(); // if last page, HIDE the button

                } else {
                    $('[js-more-anims]').hide(); // if no data, HIDE the button as well
                }
            }
        });
        return false;
    });


    $('[js-anim-form]').change(function () {
        var filter = $('[js-anim-form]');
        $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
            beforeSend: function (xhr) {
                $('[js-more-anims]').hide();
                $('[js-anim-results]').html('<div class="loading-wrapper"><div class="loading"></div></div>');
            },
            success: function (data) {

                // console.log(data)
                let parsedData = JSON.parse(data);
                console.log(parsedData);
                // when filter applied:
                // set the current page to 1
                animation_loadmore_params.current_page = 1;

                // set the new query parameters
                animation_loadmore_params.posts = parsedData.posts;

                // set the new max page parameter
                animation_loadmore_params.max_page = parsedData.max_page;

                $('[js-anim-results]').html(parsedData.content); // insert data
                init();
                if (parsedData.max_page < 2) {
                    $('[js-more-anims]').hide();
                } else {
                    $('[js-more-anims]').show();
                }
            }
        });
        return false;
    });
});

